import { IPurchaseIndentUpload } from "common/interface/IPurchaseIndent";

const STORAGE_KEY = "processingVendorAssignment";

export const persistProcessingVendorAssignment = (data: IPurchaseIndentUpload) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const getPersistedProcessingVendorAssignment = (): IPurchaseIndentUpload => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : {};
};

export const removePersistedProcessingVendorAssignment = () => {
  localStorage.removeItem(STORAGE_KEY);
};
